"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dynosEditor = dynosEditor;
exports.DEFAULT_DYNO = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _underscore = require("underscore");

var _ReducerUtils = require("lead-flows-ui/utils/ReducerUtils");

var _Strings = require("lead-flows-ui/constants/Strings");

var _DynoTypes = _interopRequireDefault(require("lead-flows-ui/constants/DynoTypes"));

var _FormFieldUtils = require("lead-flows-ui/utils/FormFieldUtils");

var _FormFieldTypes = _interopRequireDefault(require("lead-flows-ui/constants/FormFieldTypes"));

var _RedirectButtonType = _interopRequireDefault(require("lead-flows-ui/constants/RedirectButtonType"));

var DEFAULT_DYNO = {
  name: _Strings.DEFAULT_DYNO_NAME,
  enabled: false,
  scheduled: false,
  type: _DynoTypes.default.POP_OVER,
  sendNotifications: true,
  espSubscriptionsCount: 0,
  color: '#3288E6',
  heading: '',
  cta: '',
  completedMessageHtml: '',
  description: '',
  displayOnMobile: true,
  displayOnScroll: false,
  displayOnExitIntent: false,
  displayOnTimedDelay: 0,
  showNames: false,
  showPhone: false,
  legalConsentOptions: null,
  locale: 'en',
  doubleOptInEnabled: true,
  whitelistedUrls: [],
  pageTypesList: [],
  formFields: [(0, _FormFieldUtils.generateFormField)({
    name: _FormFieldTypes.default.EMAIL
  }, 'en')],
  notificationEmails: [],
  ignoreDurationDays: 14,
  dismissButtonEnabled: false,
  audience: null,
  calloutButtonType: _RedirectButtonType.default.GO_TO_FORM_STEP
};
exports.DEFAULT_DYNO = DEFAULT_DYNO;
var INITIAL_STATE = {
  dynosEditor: {
    hasLoaded: false,
    fetchingHasError: false,
    fetchingRecentError: undefined,
    lastFetched: undefined,
    saving: false,
    savingHasError: false,
    savingRecentError: undefined,
    hasChanges: false,
    lastSaveAt: undefined,
    validation: {},
    editableDyno: DEFAULT_DYNO,
    kickbackPreviews: [],
    kickbackIsFetching: false,
    hasErrorFetchingPreviews: false
  }
};

function dynosEditor() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE.dynosEditor;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.SET_EDITOR_STEP:
      return Object.assign({}, state, {
        step: action.payload.step
      });

    case _ActionTypes.SET_EDITOR_DYNO_ID:
      return Object.assign({}, state, {
        dynoId: action.payload.id
      });
    // EDITOR DYNO

    case _ActionTypes.REQUEST_DYNO_FOR_EDITOR:
      return Object.assign({}, state, {
        hasLoaded: false,
        isLoading: true
      });

    case _ActionTypes.DELETE_DRAFT_SUCCESS:
      return Object.assign({}, state, {
        hasLoaded: false,
        isLoading: false
      });

    case _ActionTypes.RECIEVE_DYNO_FOR_EDITOR:
      {
        var payloadUrlWhitelist = (0, _ReducerUtils.csvToList)(action.payload.urlWhitelist);
        var payloadPageTypes = (0, _ReducerUtils.csvToList)(action.payload.pageTypes);
        var timedDelay = action.payload.displayOnTimedDelay < 7000 && action.payload.displayOnTimedDelay !== 0 ? 7000 : action.payload.displayOnTimedDelay;
        return Object.assign({}, state, {
          hasLoaded: true,
          isLoading: false,
          editableDyno: Object.assign({}, state.editableDyno, (0, _extends2.default)({}, action.payload, {
            whitelistedUrls: payloadUrlWhitelist,
            pageTypesList: payloadPageTypes,
            displayOnTimedDelay: timedDelay
          }))
        });
      }

    case _ActionTypes.REQUEST_AUDIENCE_FORMAT:
      return Object.assign({}, state, {
        hasLoaded: false,
        isLoading: true
      });

    case _ActionTypes.RECEIVE_AUDIENCE_FORMAT:
      return Object.assign({}, state, {
        hasLoaded: true,
        isLoading: false,
        editableDyno: Object.assign({}, state.editableDyno, {
          audience: (0, _extends2.default)({}, state.audience, {
            filter: action.payload
          })
        })
      });

    case _ActionTypes.ERROR_RECEIVE_AUDIENCE_FORMAT:
    case _ActionTypes.ERROR_DYNO_FOR_EDITOR:
      return Object.assign({}, state, {
        hasLoaded: true,
        isLoading: false,
        fetchingHasError: true,
        fetchingRecentError: action.payload
      });

    case _ActionTypes.UPDATE_EDITABLE_DYNO:
      {
        if (action.payload.whitelistedUrls) {
          action.payload.urlWhitelist = (0, _ReducerUtils.listToCsv)(action.payload.whitelistedUrls);
        }

        if (action.payload.pageTypesList) {
          action.payload.pageTypes = (0, _ReducerUtils.listToCsv)(action.payload.pageTypesList);
        }

        (0, _underscore.each)(Object.keys(action.payload || {}), function (key) {
          if (action.payload[key] === '') {
            action.payload[key] = null;
          }
        });

        if ((0, _underscore.isEmpty)(action.payload.kickbackEmails)) {
          return Object.assign({}, state, {
            hasChanges: true,
            editableDyno: Object.assign({}, state.editableDyno, action.payload)
          });
        }

        return Object.assign({}, state, {
          hasChanges: true,
          editableDyno: Object.assign({}, state.editableDyno, action.payload, {
            kickbackEmails: action.payload.kickbackEmails
          })
        });
      }

    case _ActionTypes.CLEAR_EDITABLE_DYNO:
      return Object.assign({}, state, {
        hasLoaded: false,
        saving: false,
        savingHasError: false,
        savingRecentError: undefined,
        hasChanges: false,
        validation: {},
        editableDyno: INITIAL_STATE.dynosEditor.editableDyno
      });
    // VALIDATION ERRORS

    case _ActionTypes.ADD_VALIDATION_ERROR:
      return Object.assign({}, state, {
        validation: Object.assign({}, state.validation, (0, _defineProperty2.default)({}, action.payload.step, Object.assign({}, state.validation[action.payload.step], (0, _defineProperty2.default)({}, action.payload.field, action.payload.message))))
      });

    case _ActionTypes.REMOVE_VALIDATION_ERROR:
      {
        var _action$payload = action.payload,
            step = _action$payload.step,
            field = _action$payload.field;
        var cloned = (0, _underscore.clone)(state.validation);

        if (Object.keys(cloned[step] || {}).length > 1) {
          delete cloned[step][field];
        } else {
          delete cloned[step];
        }

        return Object.assign({}, state, {
          validation: Object.assign({}, cloned)
        });
      }

    case _ActionTypes.RESET_VALIDATION_ERRORS:
      {
        return Object.assign({}, state, {
          validation: {}
        });
      }
    // IMAGE UPLOAD

    case _ActionTypes.UPLOAD_DYNO_IMAGE_SUCCESS:
      return Object.assign({}, state, {
        hasChanges: true,
        editableDyno: Object.assign({}, state.editableDyno, {
          imageFileName: action.payload.fileName,
          imageOriginalUrl: action.payload.originalUrl,
          imageResizedUrl: action.payload.resizedUrl
        })
      });

    case _ActionTypes.REMOVE_UPLOAD_DYNO_IMAGE:
      return Object.assign({}, state, {
        hasChanges: true,
        editableDyno: Object.assign({}, state.editableDyno, {
          imageFileName: null,
          imageOriginalUrl: null,
          imageResizedUrl: null
        })
      });
    // SAVE DYNO

    case _ActionTypes.AUTO_SAVE_DYNO:
      return Object.assign({}, state, {
        saving: true
      });

    case _ActionTypes.CANCEL_AUTO_SAVE_DYNO:
      return Object.assign({}, state, {
        saving: false
      });

    case _ActionTypes.SAVE_DYNO:
      return Object.assign({}, state, {
        saving: true,
        editableDyno: Object.assign({}, state.editableDyno, {
          notificationEmails: (0, _underscore.without)(state.editableDyno.notificationEmails, '')
        })
      });

    case _ActionTypes.SAVE_DYNO_SUCCESS:
      return Object.assign({}, state, {
        saving: false,
        savingHasError: false,
        hasChanges: false,
        lastSaveAt: action.meta.timestamp,
        editableDyno: Object.assign({}, state.editableDyno, action.payload)
      });

    case _ActionTypes.SAVE_DYNO_ERROR:
      return Object.assign({}, state, {
        saving: false,
        savingHasError: true,
        savingRecentError: action.payload
      });

    case _ActionTypes.SAVE_DRAFT:
      return Object.assign({}, state, {
        saving: true,
        editableDyno: Object.assign({}, state.editableDyno, {
          notificationEmails: (0, _underscore.without)(state.editableDyno.notificationEmails, '')
        })
      });

    case _ActionTypes.SAVE_DRAFT_SUCCESS:
      return Object.assign({}, state, {
        saving: false,
        savingHasError: false,
        hasChanges: false,
        lastSaveAt: action.meta.timestamp,
        editableDyno: Object.assign({}, state.editableDyno, action.payload)
      });

    case _ActionTypes.SAVE_DRAFT_ERROR:
      return Object.assign({}, state, {
        saving: false,
        savingHasError: true,
        savingRecentError: action.payload
      });

    case _ActionTypes.REQUEST_KICKBACKS:
      return Object.assign({}, state, {
        editableDyno: Object.assign({}, state.editableDyno, {
          kickbackIsFetching: true
        })
      });

    case _ActionTypes.ERROR_KICKBACKS:
      return Object.assign({}, state, {
        editableDyno: Object.assign({}, state.editableDyno, {
          previewServerResponse: {
            isError: true,
            responseCode: action.payload
          },
          kickbackIsFetching: false,
          kickbackPreviews: []
        })
      });

    case _ActionTypes.RECEIVE_KICKBACK_PREVIEWS:
      return Object.assign({}, state, {
        editableDyno: Object.assign({}, state.editableDyno, {
          kickbackPreviews: action.payload,
          kickbackIsFetching: false,
          previewServerResponse: {
            isError: false,
            responseCode: 200
          }
        })
      });

    default:
      return state;
  }
}